import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import axiosInstance from '../../../utils/axiosInstance';

export default function CakeProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(`/api/products/getcakes/pagination?page=${currentPage}`);
        setProducts(response.data);
        setHasMore(response.data.length > 0);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentPage]);

  const handleShowMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handleShowLess = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <h1 className='font-bold'> Only cake Products</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
      {products.map((product) => (
        <Link to={`/admin/update/${product._id}`} key={product._id}>
          <div className="bg-white p-4 rounded-md hover:shadow-xl transition duration-300 transform hover:scale-105">
            <img
              src={`${axiosInstance.defaults.baseURL}/${product.image}`}
              alt={product.name}
              className="w-full h-40 object-cover mb-4 rounded"
            />

            <div>
              <p className="text-lg font-bold mb-2 text-amber-500">{product.name}</p>
              <p className="text-base mb-2 text-green-500">Rs:{product.price}</p>
              {product.description && (
                <p className="text-sm mb-2">{product.description}</p>
              )}

              
              {product.category && (
                <p className="text-sm mb-2 font-roboto">
                  <span>
                    <> {product.category}</>
                  </span>
                </p>
              )}
            </div>

            <div className="flex justify-between mt-4">
              <Link
                to={`/admin/update/${product._id}`}
                className="text-blue-500 hover:underline"
              >
                Update
              </Link>
              {/* Add your delete logic here */}
            </div>
          </div>
        </Link>
      ))}
      </div>

      <div className="mt-4 flex justify-between">
        <button
          onClick={handleShowLess}
          className={`bg-blue-500 text-white px-4 py-2 rounded ${currentPage === 1 && 'opacity-50 cursor-not-allowed'}`}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <button
          onClick={handleShowMore}
          className={`bg-blue-500 text-white px-4 py-2 rounded ${!hasMore && 'opacity-50 cursor-not-allowed'}`}
          disabled={!hasMore}
        >
          Next
        </button>
      </div>
    </>
  );
}
